import styled from 'styled-components'

import { statisticOrientations } from '@/common/components/Statistic/constants'

const isHorizontal = props => props.orientation === statisticOrientations.horizontal

export const Container = styled.div`
  display: flex;
  flex-direction: ${props => (isHorizontal(props) ? 'row' : 'column')};
  background-color: ${props => props.theme.colors.background.primary};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  border-radius: ${props => props.theme.primitives.radius.radius1};
  overflow: hidden;

  & > * + * {
    ${props => (isHorizontal(props) ? 'border-left' : 'border-top')}: ${props => props.theme.stroke.default} solid
      ${props => props.theme.colors.border.default};
  }
`
